import React, { useState, useEffect } from "react";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { useDispatch } from "react-redux";

import { UserProfileFields } from "globalConstants";
import { uiActions } from "store";

import EditableField from "../forms/editableField ";

const { MobilePhone } = UserProfileFields;

type EditableMobilePhoneFieldProps = {
	isLoading: boolean;
	mobilePhoneDefault: string;
};

const EditableMobilePhoneField = ({
	isLoading,
	mobilePhoneDefault,
}: EditableMobilePhoneFieldProps) => {
	const dispatch = useDispatch();

	const [mobilePhoneValue, setMobilePhoneValue] =
		useState<string>(mobilePhoneDefault);

	useEffect(() => {
		setMobilePhoneValue(mobilePhoneDefault);
	}, [mobilePhoneDefault]);

	const openModal = () => {
		dispatch(
			uiActions.showModal("EDIT_MOBILE_PHONE_NUMBER", {
				mobilePhoneValue,
				setMobilePhoneValue,
			}),
		);
	};

	return (
		<EditableField
			label={MobilePhone.displayName}
			colLabel={5}
			colValue={7}
			value={formatPhoneNumberIntl(mobilePhoneValue)}
			isLoading={isLoading}
			onClick={openModal}
		/>
	);
};

export default EditableMobilePhoneField;
